<template>
  <div class="list">
    <Headers></Headers>
    <div
      class="banner"
      style="background: url(/static/banner/banner1.jpg) center"
    >
      <div class="box">
        <div class="left"></div>
        <div class="container">
          <div class="title">细胞鉴定相关文献下载区</div>
          <div class="entitle">
            Cell identification related literature download area
          </div>
        </div>
        <div class="right"></div>
      </div>
    </div>
    <div class="listbox">
      <div class="container">
        <div class="list" v-if="list.length > 0">
          <el-row>
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="24"
              v-for="(item, index) in list"
              :key="index"
            >
              <div class="item">
                <div class="text">
                  <div class="title">{{ item.title }}</div>
                  <div class="info" v-if="item.description">
                    {{ item.description }}
                  </div>
                  <router-link
                    :to="{
                      path: $Router.literaturecontent.path,
                      query: {
                        id: item.id,
                      },
                    }"
                    class="more"
                  >
                    查看详情 >>
                  </router-link>
                </div>
                <div class="img">
                  <img :src="item.cover_img" alt="" v-if="item.cover_img" />
                  <img src="/static/news/1.png" alt="" v-else />
                </div>
              </div>
            </el-col>
          </el-row>
          <div class="pages">
            <el-pagination
              background
              layout="prev, pager, next"
              :pager-count="5"
              :page-size="limit"
              :total="total"
              @current-change="currentChange"
              :current-page="page"
            >
            </el-pagination>
          </div>
        </div>
        <unllimg v-else></unllimg>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from '@/components/header/header.vue'
import Footer from '@/components/footer/footer.vue'
import unllimg from '@/components/unllimg/unllimg.vue'
import service from './list'
import { setmeta } from '@/assets/js/setmeta'

export default {
  name: 'list',
  mixins: [setmeta],
  data () {
    return {
      cate_id: 8,
      limit: 8,
      total: 0,
      page: 1,
      list: []
    }
  },
  components: {
    Headers,
    Footer,
    unllimg
  },
  methods: {
    currentChange (index) {
      this.page = index
      service.getWebArticleList(this)
    }
  },
  created () {
    this.setMetaConfig({
      web_title: `细胞鉴定相关文献下载区-${this.$env.TITLE}`
    })
    service.getWebArticleList(this)
  }
}
</script>

<style lang="scss" scoped>
@import "./list";
</style>



// WEBPACK FOOTER //
// src/views/literature/list/list.vue